import { errorsResx } from "~/resxDist/errorsResx";
import { getResxWithBrandName } from "../../../common/branding";
import { commonResx } from "../../../resxDist/commonResx";
import { Action, ApiErrorTypes } from "../../Actions";
import { ObjectNotFoundAction, UnknownErrorAction, UserFriendlyErrorAction } from "../../Actions/errorActions";
import { apiMiddlewareActionTypes } from "../../Middleware/apiMiddlewareActionTypes";
import { UserFriendlyDialogActionTypes as DialogActionTypes } from "../actions";

type UserFriendlyActions =
    | ObjectNotFoundAction
    | Action<DialogActionTypes.ON_CLOSE>
    | UserFriendlyErrorAction
    | UnknownErrorAction;

export interface UserFriendlyDialogState {
    isOpen: boolean;
    message: string;
    withoutReInit?: boolean;
    callback?: Fn<any>;
}
type State = UserFriendlyDialogState;

type ufDialogReducer = (state: State, action: UserFriendlyActions) => State;
export const userFriendlyDialogReducer: ufDialogReducer = (state = getInitialErrorDialogState(), action) => {
    if (handlers.hasOwnProperty(action.type)) {
        return handlers[action.type](state, action);
    }
    return state;
};
const handlers: any = {
    [apiMiddlewareActionTypes.API_OBJECT_NOT_FOUND]: openDialog,
    [apiMiddlewareActionTypes.API_USER_FRIENDLY_EXC]: openDialog,
    [ApiErrorTypes.UnknownError]: openDialog,
    [DialogActionTypes.ON_CLOSE]: closeDialog,
};

const getInitialErrorDialogState = () =>
    <UserFriendlyDialogState>{
        isOpen: false,
        message: "",
    };

function openDialog(state: State, action: ObjectNotFoundAction | UserFriendlyErrorAction | UnknownErrorAction): State {
    return {
        ...state,
        isOpen: true,
        message: getErrorMessage(action),
        withoutReInit: action.withoutReInit,
        callback: action.callback,
    };
}

const getErrorMessage = (action: ObjectNotFoundAction | UserFriendlyErrorAction | UnknownErrorAction) => {
    if (action.type === apiMiddlewareActionTypes.API_OBJECT_NOT_FOUND) {
        return ep.errorManager.getObjectNotFoundErrorMsg(action.body);
    }

    if (action.type === apiMiddlewareActionTypes.API_USER_FRIENDLY_EXC) {
        const { body } = action;

        return getResxWithBrandName(
            commonResx[body.ErrorKey] ??
                errorsResx[body.ErrorKey as keyof typeof errorsResx] ??
                body.Message ??
                body.detail
        );
    }

    return action.message || commonResx.UnknownErrorMessage;
};

function closeDialog(state: State, action: Action<DialogActionTypes.ON_CLOSE>): State {
    return {
        ...state,
        isOpen: false,
        message: "",
    };
}
